(() => {
  const panel = document.querySelector('[data-reef-logo-preview]');
  const options = document.querySelector('[data-pcna-options]');
  if (!panel || !options || panel.dataset.initialized) return;
  panel.dataset.initialized = 'true';
  const form = options.closest('form');
  const copy = JSON.parse(panel.querySelector('[data-logo-copy]').textContent);
  const catalogue = JSON.parse(options.querySelector('[data-pcna-catalogue]').textContent) || {};
  const previewUpload = panel.querySelector('[data-logo-preview-file]');
  const status = panel.querySelector('[data-logo-status]');
  const result = panel.querySelector('[data-logo-result]');
  const art = panel.querySelector('[data-logo-art]');
  const bottle = panel.querySelector('.neps-logo-preview__bottle');
  const stage = panel.querySelector('.neps-logo-preview__stage');
  const contrastNote = panel.querySelector('[data-logo-contrast-note]');
  const selection = panel.querySelector('[data-logo-selection]');
  const scale = panel.querySelector('[data-logo-scale]');
  const inkPicker = panel.querySelector('[data-logo-ink]');
  const inkControl = panel.querySelector('[data-logo-ink-control]');
  const inkValue = panel.querySelector('[data-logo-ink-value]');
  const removeBackground = panel.querySelector('[data-logo-remove-background]');
  const backgroundControl = panel.querySelector('[data-logo-background-control]');
  const backgroundSettings = panel.querySelector('[data-logo-background-settings]');
  const tolerance = panel.querySelector('[data-logo-tolerance]');
  const filename = panel.querySelector('[data-logo-filename]');
  const tools = window.nepsLogoTools;
  const inkDetails = options.querySelector('[data-pcna-ink-details]');
  const isFullColour = () => {
    const selectedMethod = options.querySelector('[data-pcna-method]').value;
    return selectedMethod === '71' || (catalogue.configPricing && options.querySelector('[data-pcna-ink]').value !== '1');
  };
  let objectURL, revision = 0, original, basePixels, processed, processedKey, renderedKey, renderedURL;
  let inkManual = false;
  const colourNames = {white:'#ffffff',black:'#000000',red:'#ff0000',blue:'#0000ff',navy:'#000080',green:'#008000',yellow:'#ffff00',orange:'#ffa500',magenta:'#ff00ff',purple:'#800080',grey:'#808080',gray:'#808080'};
  function requestedInk() {
    const text = inkDetails?.value.trim().toLowerCase();
    return /^#[a-f0-9]{6}$/.test(text || '') ? text : colourNames[text];
  }
  function recordInk() {
    if (!inkDetails || isFullColour()) return;
    inkDetails.value = inkPicker.value.toUpperCase();
    inkDetails.dispatchEvent(new Event('input', {bubbles:true}));
  }
  function prepareArtwork() {
    const key = removeBackground.checked + ':' + tolerance.value;
    if (key === processedKey) return;
    processed = removeBackground.checked ? tools.removeBackground(basePixels, Number(tolerance.value)) : basePixels;
    processedKey = key;
    renderedKey = null;
    if (!inkManual) inkPicker.value = tools.dominantColour(processed.data);
    backgroundSettings.hidden = !removeBackground.checked;
  }
  function clear() {
    revision++;
    result.hidden = true;
    original = null;
    basePixels = processed = processedKey = renderedKey = renderedURL = null;
    removeBackground.checked = false;
    backgroundSettings.hidden = true;
    stage.classList.remove('neps-logo-preview__stage--contrast');
    contrastNote.hidden = true;
    art.removeAttribute('src');
    if (objectURL) URL.revokeObjectURL(objectURL);
    objectURL = null;
  }
  function refresh() {
    if (!original) return;
    const sku = options.querySelector('input[name="neps_pcna_colour"]:checked')?.value;
    const method = options.querySelector('[data-pcna-method]');
    const location = options.querySelector('[data-pcna-location]');
    const name = location.selectedOptions[0]?.textContent || '';
    const back = /back/i.test(name) && !/front|both/i.test(name);
    const wrap = /wrap/i.test(name);
    const selectedColour = options.querySelector('input[name="neps_pcna_colour"]:checked');
    const colourLabel = selectedColour?.closest('label')?.textContent.trim().replace(/\s*\([^)]*\)/g, '') || '';
    const explicitPhoto = catalogue.previewPhotoBySKU?.[sku];
    const galleryMedia = JSON.parse(document.querySelector('[data-pcna-all-images]')?.textContent || '[]');
    const nativePhoto = explicitPhoto?.mediaId ? galleryMedia.find(m => String(m.id) === explicitPhoto.mediaId.split('/').pop()) : null;
    const thumb = Array.from(document.querySelectorAll('[data-pcna-thumb]')).find(t =>
      (catalogue.photoColours?.[t.dataset.alt] === sku || (colourLabel && t.dataset.alt.toLowerCase().includes(colourLabel.toLowerCase()))) &&
      new RegExp('blank ' + (back ? 'back' : 'front') + ' view', 'i').test(t.dataset.alt));
    if ((!thumb && !explicitPhoto) || wrap) {
      result.hidden = true;
      status.textContent = wrap ? copy.wrap : copy.error;
      return;
    }
    bottle.src = nativePhoto?.preview_image?.src || nativePhoto?.src || explicitPhoto?.url || thumb.dataset.image;
    bottle.removeAttribute('srcset');
    bottle.alt = explicitPhoto?.alt || thumb.dataset.alt;
    const colour = (catalogue.colours || []).find(c => c.sku === sku)?.name || '';
    const digital = isFullColour();
    const previewArea = panel.querySelector('.neps-logo-preview__area');
    const geometries = catalogue.previewGeometryBySKU?.[sku] || catalogue.previewGeometry;
    const geometry = geometries?.[name] || geometries?.default;
    if (geometry) {
      const chosenMethod = (catalogue.methods || []).find(m => m.id === (method.value === 'included' ? catalogue.configPricing?.defaultMethodId : method.value));
      const chosenLocation = chosenMethod?.locations.find(l => (!l.sku || l.sku === sku) && (location.value === 'default' || l.id === location.value));
      const width = geometry.width * Math.min(1, (chosenLocation?.widthIn || geometry.referenceWidthIn) / geometry.referenceWidthIn);
      const height = geometry.height * Math.min(1, (chosenLocation?.heightIn || geometry.referenceHeightIn) / geometry.referenceHeightIn);
      previewArea.style.left = (geometry.left + (geometry.width - width) / 2) + '%';
      previewArea.style.top = (geometry.top + (geometry.height - height) / 2) + '%';
      previewArea.style.width = width + '%';
      previewArea.style.height = height + '%';
    }
    prepareArtwork();
    inkControl.hidden = digital;
    inkValue.textContent = inkPicker.value.toUpperCase();
    const transparent = original.hasTransparency || removeBackground.checked;
    const isClear = /clear/i.test(colour || colourLabel) || /(?:^|[-_])CL$/.test(sku || '') || /6569CL$/.test(sku || '');
    const rgb = inkPicker.value.match(/[a-f0-9]{2}/gi).map(value => parseInt(value, 16));
    const contrast = isClear && !digital && transparent && rgb.every(value => value >= 225);
    stage.classList.toggle('neps-logo-preview__stage--contrast', contrast);
    contrastNote.hidden = !contrast;
    const key = [processedKey, digital, transparent, inkPicker.value].join(':');
    if (key !== renderedKey) {
      const canvas = document.createElement('canvas');
      canvas.width = processed.width;
      canvas.height = processed.height;
      const context = canvas.getContext('2d');
      context.putImageData(new ImageData(new Uint8ClampedArray(processed.data), processed.width, processed.height), 0, 0);
      if (!digital && transparent) {
        context.globalCompositeOperation = 'source-in';
        context.fillStyle = inkPicker.value;
        context.fillRect(0, 0, canvas.width, canvas.height);
      }
      renderedURL = canvas.toDataURL('image/png');
      renderedKey = key;
    }
    if (art.src !== renderedURL) art.src = renderedURL;
    art.style.width = scale.value + '%';
    selection.textContent = [colour, method.selectedOptions[0]?.textContent, name].filter(Boolean).join(' · ');
    status.textContent = digital ? copy.digital : transparent ? copy.single : copy.opaque;
    result.hidden = false;
  }
  async function loadLogo(file) {
    clear();
    filename.textContent = '';
    if (!file) { status.textContent = copy.waiting; return; }
    if (!['image/png', 'image/jpeg'].includes(file.type)) { status.textContent = copy.format; return; }
    filename.textContent = file.name;
    if (file.size > 5 * 1024 * 1024) { status.textContent = copy.large; return; }
    const current = revision;
    objectURL = URL.createObjectURL(file);
    const image = new Image();
    image.src = objectURL;
    try {
      await image.decode();
      if (current !== revision) return;
      if (image.naturalWidth * image.naturalHeight > 12000000) throw new Error('large');
      const probe = document.createElement('canvas');
      const ratio = Math.min(1, 1000 / Math.max(image.naturalWidth, image.naturalHeight));
      probe.width = Math.max(1, Math.round(image.naturalWidth * ratio));
      probe.height = Math.max(1, Math.round(image.naturalHeight * ratio));
      const context = probe.getContext('2d');
      context.drawImage(image, 0, 0, probe.width, probe.height);
      basePixels = context.getImageData(0, 0, probe.width, probe.height);
      const pixels = basePixels.data;
      image.hasTransparency = pixels.some((value, index) => index % 4 === 3 && value < 255);
      backgroundControl.hidden = image.hasTransparency;
      inkManual = Boolean(requestedInk());
      inkPicker.value = requestedInk() || tools.dominantColour(pixels);
      original = image;
      refresh();
    } catch (_) {
      if (current === revision) { clear(); status.textContent = copy.error; }
    }
  }
  previewUpload.addEventListener('change', () => loadLogo(previewUpload.files?.[0]));
  options.addEventListener('change', () => setTimeout(refresh, 0));
  scale.addEventListener('input', refresh);
  inkPicker.addEventListener('input', () => { inkManual = true; recordInk(); refresh(); });
  inkDetails?.addEventListener('input', () => {
    const colour = requestedInk();
    if (colour) { inkPicker.value = colour; inkManual = true; refresh(); }
  });
  removeBackground.addEventListener('change', refresh);
  let toleranceFrame;
  tolerance.addEventListener('input', () => {
    cancelAnimationFrame(toleranceFrame);
    toleranceFrame = requestAnimationFrame(refresh);
  });
  window.addEventListener('pagehide', () => { if (objectURL) URL.revokeObjectURL(objectURL); });
})();




